import React, {useState, useEffect} from "react";
import { sendStudentUpdatePickupLocationRequest } from "../../Actions/CourseA";
import LocationPopupImage from "./Assets/LocationPopup.png";
import { useDispatch, useSelector } from 'react-redux';
import PickupApprovedImage from "./Assets/PickupApproved.svg"

const PickupApprovedPopup = ({setOpenPickupApprovePopup, Offers, handleAction }) => {

  const closePopup = () =>{
      console.log("Close icon clicked");
      setOpenPickupApprovePopup(false)
  }

    return (
        <div className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="relative rounded-[23px] bg-gradient-to-r from-white to-[#D6D8FF] p-[20px] shadow-lg w-[350px]">
            <div className="absolute top-2 right-2">
                <img
                    className="absolute right-3 top-[4px] cursor-pointer"
                    src={require("./Assets/Cross.svg").default}
                    alt=""
                    onClick={closePopup}
                />
            </div>

            <div className="w-full flex flex-col gap-[10px] justify-center items-center">
                <p className="text-[18px] text-center text-[#000000] font-bold">Confirm Pickup payment</p>
                <img src={PickupApprovedImage} alt="LocationPPickupApprovedImageopupImage" />          
                <p className="text-[18px] text-center text-[#000000]">If you proceed your "current payment method" will be charged with ${Offers} amount.</p>
      

                <div className='flex justify-center items-center gap-[10px] lg:gap-[15px] '>
                        <button className='w-[150px] h-[35px] text-[14px] lg:text-[14px] text-center text-[#4C34AD] rounded-[10px] font-bold cursor-pointer'
                        style={{
                            border: '1px solid #4C34AD'
                        }}
                        onClick={closePopup}
                    >
                            Cancel
                        </button>

                        <button
                        className={`w-[150px] h-[35px] text-[14px] lg:text-[14px] text-center rounded-[10px] text-[#FFFFFF] font-bold bg-[#4C34AD] cursor-pointer`}
                        onClick={() => handleAction("Approved")}
                        >
                            Confirm
                        </button>
                </div>
            </div>
        </div>
        </div>
    );
  };

export default PickupApprovedPopup;
